const CODE = {
  initial: `\
.container {
  display: grid;
  place-content: center;
}

.element {
  grid-row: 1;
  grid-column: 1;
}`,
  'different-sizes': `\
.container {
  display: grid;
  place-content: center;
  place-items: center;
}

.element {
  grid-row: 1;
  grid-column: 1;
}`,
  'toggleable-place-items': `\
.container {
  display: grid;
  place-content: center;
}

.element {
  grid-row: 1;
  grid-column: 1;
}`,
};

export function getInitialPlaceItems(variant: keyof typeof CODE) {
  return variant === 'toggleable-place-items' ? 'start' : 'center';
}

export function constructSnippet(
  variant: keyof typeof CODE,
  placeItems: 'center' | 'start'
) {
  let code = CODE[variant];

  if (
    variant === 'toggleable-place-items' &&
    placeItems === 'center'
  ) {
    code = CODE['different-sizes'];
  }

  return code;
}
